module.exports = __webpack_public_path__ + "static/media/Style7.e214477e.PNG";